import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime, defineProperty as _defineProperty, objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { buildUrl } from '../json-api/JsonApiUtils.js';
var getIdSet = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var endpoint, filters, page, pageSize, query, entity, sortValue, authToken, extraFields, fields, url, headers, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          endpoint = _ref.endpoint, filters = _ref.filters, page = _ref.page, pageSize = _ref.pageSize, query = _ref.query, entity = _ref.entity, sortValue = _ref.sortValue, authToken = _ref.authToken, extraFields = _ref.extraFields;
          fields = extraFields ? "id,".concat(extraFields) : 'id';
          url = buildUrl(endpoint, {
            filters: filters,
            sorts: sortValue ? [{
              value: sortValue
            }] : null,
            page: {
              number: page,
              size: pageSize
            },
            query: query,
            fields: _defineProperty({}, entity, fields)
          });
          headers = _objectSpread2({
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache'
          }, authToken && {
            Authorization: "Bearer ".concat(authToken)
          });
          _context.next = 6;
          return fetch(url, {
            method: 'GET',
            headers: headers,
            credentials: 'include'
          });
        case 6:
          response = _context.sent;
          return _context.abrupt("return", response.json());
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getIdSet(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export { getIdSet };